import React from 'react';

import VirtualMachineFilter from './filters/VirtualMachineFilter';

const DrawerVMPanel = () => <VirtualMachineFilter />;

export default DrawerVMPanel;
